import { Component, OnDestroy, inject } from '@angular/core';
import { ProjectDataService } from './project-details/state-and-data-handling/project-data.service';

@Component({
  selector: 'app-projects',
  templateUrl: './project.component.html',
  standalone: false,
})
export class ProjectComponent implements OnDestroy {
  private readonly projectService = inject(ProjectDataService);

  ngOnDestroy(): void {
    this.projectService.resetProjectStore();
  }
}
